/* eslint-disable */
import {getMentionList, getMentionCardDetail} from '@/libs/api/api'
import {find, isEmpty, uniq, uniqBy} from 'lodash'
export default {
    mounted() {
        this.getMentionList()
        // fetch mention list every 15 mins
        this.interval = setInterval(() => {
            this.getMentionList()
          }, 15 * 60 * 1000)
    },
    beforeDestroy () {
        // clear interval when component destroyed
        clearInterval(this.interval)
    },
    data() {
        return {
            mentionList: [],
            cardDetailList: [],
            hoveredItem: {},
            interval: null
        }
    },
    methods: {
      /**
         * to get the mention list
         */
        async getMentionList () {
            try {
                if (this.$route.params.id && this.$route.params.id !== '' && this.$route.params.id !== undefined && this.$route.params.id !== null) {
                    // body for api
                    let body = {
                        organisation: this.$route.params.id
                    }
                    // api call
                    let response = await getMentionList(body)
                    // intialise list
                    this.mentionList = response
                    // save to store
                    this.$store.dispatch('setMentionList', response)
                }
            } catch (error) {
                console.error(error)
            }
        },
        getHtmlTemplate (item) {
            let name = item.name || ''
            if (item.first_name) name = item.first_name
            if (item.last_name) name = `${name} ${item.last_name}`
            let html = `
            <div class="quill-container-list">
                <img src="${item.avatar_image}">
                <div class="quill-name">
                    <span>${name}</span>
                </div>
            </div>`
            return html
        },
        /**
         * to add event listener for mention tags
         * and initialise the return template
         */
        registerHoveCard () {
            let self = this
            $(".mention").each(function () {
                var $pElem = $(this);
                $pElem.popover(
                    {
                        html: true,
                        trigger: "manual",
                        placement: 'auto',
                        container: 'body',
                        animation:false,
                        content: function () {
                            let id = $(this).data('id')
                            return self.selectHoveredItem(id)
                        }
                    }
                );
            }).on("mouseenter", function () {
                var _this = this;
                $(this).popover("show");
                $(".popover").on("mouseleave", function () {
                    $(_this).popover('hide');
                });
            }).on("mouseleave", function () {
                var _this = this;
                setTimeout(function () {
                    if (!$(".popover:hover").length) {
                        $(_this).popover("hide");
                    }
                }, 100);
            });
        },

        /**
         * to get the element from mention list 
         * and return the html template for popup
         * @param {*} id 
         */
        selectHoveredItem (id) {
            this.hoveredItem = {}
            let html = '<div class="hover-card-container"><p>No results found..</p></div>'
            if (id !== undefined && id !== null) {
                let hoveredItem = find(this.cardDetailList, {_id: id || id})
                this.hoveredItem = hoveredItem !== undefined ? hoveredItem : {}
                if (!isEmpty(this.hoveredItem)) {
                    let name = (this.hoveredItem.name) || ''
                    if (this.hoveredItem.first_name) name = this.hoveredItem.first_name
                    if (this.hoveredItem.last_name) name = `${name} ${this.hoveredItem.last_name}`
                    html = `
                    <div class="hover-card-container">
                        <div class="hover-card-body">
                            <div class="hover-image">
                                <a href="${hoveredItem.link}"><img src="${this.hoveredItem.avatar_image}"></a>
                            </div>
                            <div class="hover-content hover-text">
                                    <p class="hover-name">${name || ''}</p>
                                    <p class="hover-screen-name">@${(this.hoveredItem.screen_name) || ''}</p>
                                    <p class="hover-address"> <i class="${this.hoveredItem && this.hoveredItem.address && this.hoveredItem.address !== '' && typeof this.hoveredItem.address !== 'object' ? 'nova-companylocation' : ''}"></i> ${(this.hoveredItem.address) || ''}</p>
                            </div>
                            
                        </div>
                        <div class="hover-footer hover-text">
                            <span><i class="nova-company-name"></i> <span>Part of Accura Systems</span></span>
                        </div>
                    </div>`
                }
            }
            return html
        },

        /**
         * 
         * @param {*} item 
         * @param {*} insertItem 
         */
        insertMentionItem(item, insertItem) {
            insertItem(item, true)
            this.registerHoveCard()
            let cardDetail = find(this.mentionList, {_id: item.id})
            if (!isEmpty(cardDetail)) {
                this.cardDetailList = uniqBy([...this.cardDetailList, cardDetail], '_id')
            }
        },

        /**
         * to get the mention card list
         */
        async getMentionCardDetailList (ids) {
            try {
                let cardDetail = await getMentionCardDetail({entity_ids: ids})
                return cardDetail
            } catch (error) {
                console.error('error', error)
            }
        },

        getMentionIds () {
            let ids = []
            $('.mention').each( function (id, item) {
                ids.push($(item).data('id'))
            })
            return uniq(ids)
        },
        getEditorOptions (placeholder) {
            return {
                theme: "snow",
                placeholder,
                modules: {
                    toolbar: false,
                    mention: {
                        allowedChars: /^[a-zA-Z0-9_]*$/,
                        // linkTarget: '',
                        mentionDenotationChars: ["@"],
                        renderItem: (item)=> {
                            return this.getHtmlTemplate(item)
                        },
                        source: (searchTerm, renderList)=> {
                            let values = this.mentionList;

                            if (searchTerm.length === 0) {
                                renderList(values, searchTerm);
                            } else {
                                const matches = [];
                                for (let i = 0; i < values.length; i++)
                                    if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) matches.push(values[i]);
                                renderList(matches, searchTerm);
                            }
                        },
                        dataAttributes: ['id', 'value', 'denotationChar', 'link', 'target', 'toggle'],
                        onSelect: (item, insertItem) => {
                            this.insertMentionItem(item, insertItem)
                        }
                    }
                }
            }
        }
    }
};